// A rental service's readable name: the old system's products read "SERV. ALQUILER MENSUAL DE CAMA ELECTRICA", so the
// "service of rental" part is dropped ("CAMA ELECTRICA"). Used by the Alquileres equipment cards and the dashboard's
// rental-services chart.
export const equipmentLabel = (name) => {
  const text = String(name || '');
  const short = text.replace(/^\s*SERV(ICIO)?\.?\s*(DE\s+)?(ALQ(UILER)?|AQUILER|ALQUIER)\.?\s*(MENSUAL\s+)?(DE\s+)?/i, '').trim();
  return short || text;
};

// The kind of equipment, in plain plural Spanish ("Camas", "Sillas de ruedas", "Bombas de secreción"…) — for summaries where
// the product's full name is noise and the old and new catalog's names for the same thing should count together
// ("SERV. ALQUILER DE SILLA DE RUEDA" and "Silla de ruedas estándar" are both Sillas de ruedas). First match wins, so the
// more specific rules come first; a name no rule knows keeps its own (shortened) name.
const KINDS = [
  [/SILLA DE PLAYA/, 'Sillas de playa'],
  [/SILLON/, 'Sillones reclinables'],
  [/SILLA/, 'Sillas de ruedas'],
  [/COLCHON/, 'Colchones'],
  [/CAMA/, 'Camas'],
  [/CONCENTRADOR/, 'Concentradores'],
  [/EXTRACTOR/, 'Extractores de leche'],
  [/ASPIRADOR|SECRECION/, 'Bombas de secreción'],
  [/TANQUE.*PORTATIL|PORTATIL/, 'Tanques portátiles'],
  [/TANQUE|CILINDRO/, 'Tanques de oxígeno'],
  [/NEBULIZADOR/, 'Nebulizadores'],
  [/GRUA/, 'Grúas'],
  [/MESA/, 'Mesas de hospital'],
  [/MONITOR/, 'Monitores'],
  [/ANDADOR/, 'Andadores'],
  [/MULETA/, 'Muletas'],
];
export const equipmentKind = (name) => {
  const plain = String(name || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase();
  const hit = KINDS.find(([re]) => re.test(plain));
  return hit ? hit[1] : equipmentLabel(name);
};
